import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { updateToken } from '../services/SessionService';
import { trackRequestStart, trackRequestEnd } from '../../utils/services/TopProgressService';

axios.interceptors.request.use((config:AxiosRequestConfig) => {
    const headers = retrieveHeadersFromStorage();    
    
    Object.keys(headers).forEach((key:string) => {
        config.headers[key] = headers[key];
    });

    // marca o request para que a resposta decremente o contador da barra do topo
    (config as ITrackedRequestConfig).__topProgress = trackRequestStart();

    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response:AxiosResponse) => {
    endTrackedRequest(response?.config);
    saveImportantHeadersInStorage(response);
    return response;
}, async (error) => {
    endTrackedRequest(error?.config);

    const data = error?.response?.data || {}

    // guarda o status HTTP para quem precisa diferenciar 404 de falha (ResourceErrorHelper)
    if (typeof data === 'object' && error?.response?.status) {
        data.httpStatus = error.response.status
    }

    try {
        if (error?.response?.status === 401) {
            await updateToken();
            return Promise.resolve();
        }

        return Promise.reject(data);
    } catch (e) {
        return Promise.reject(data);
    }
});

function endTrackedRequest(config?:AxiosRequestConfig):void {
    if ((config as ITrackedRequestConfig)?.__topProgress) {
        trackRequestEnd();
    }
}

function saveImportantHeadersInStorage(response:AxiosResponse):void {
    const hasAuthorizationHeader = !response.headers['authorization']
    const hasMuvenHeader = !!Object.keys(response.headers).filter((key) => {
        return isKeyMuvenRelated(key)
    }).length

    if (!hasAuthorizationHeader || !hasMuvenHeader) {
        return;
    }

    localStorage.setItem("authorization", response.headers['authorization']);

    Object.keys(response.headers).filter((key) => {
        return isKeyMuvenRelated(key)
    }).forEach((key) => {
        localStorage.setItem(key, response.headers[key]);
    })
}

function retrieveHeadersFromStorage():IHeaderObj {
    const headers:IHeaderObj = {
        authorization: `Bearer ${localStorage.getItem("authorization")}`,
    }

    Object.keys(localStorage).filter((key) => {
        return isKeyMuvenRelated(key)
    }).forEach((key) => {
        headers[key] = localStorage.getItem(key) || ""
    })

    return headers
}

function isKeyMuvenRelated(key:string):boolean {
    return /muven-/.test(key)
}

interface IHeaderObj {
    [key:string]:string
}

interface ITrackedRequestConfig extends AxiosRequestConfig {
    __topProgress?:boolean
}
